module.exports = __webpack_public_path__ + "img/salespersonShouYi.af16bf0c.png";